import WebLayout from './ColorPickerWithTextLayout.web';
import MobileLayout from './ColorPickerWithTextLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
